<template>
    <section class="pb-3 pt-4 px-0 bg-white">
        <div id="content" class="container-fluid max-w-1350 pe-0">
            <div class="pl-md-2 pr-md-2 flex-md-fill">
                <div id="resultFilter">
                    <div v-if="totalCampaigns > 0" id="contResultsFilter" class="row campaign-container">
                        <campaign v-for="(item, index) in campaigns" :key="item['campaignId']"
                                  :campaign="item" :identifier="item['campaignId']"></campaign>
                    </div>
                    <div v-else-if="isFetching" class="row col-sm-12">
                        Searching
                    </div>
                    <nav v-if="getTotalPages > 1 && limitToShow > 6" id="contPagination" class="pb-4 pt-3">
                        <div class="pagination justify-content-center pagination-lg pagination_site text-center">
                            <div class="col-sm-12 col-md-7">
                                <div id="tableFeatures_paginate" class="dataTables_paginate paging_input">
                                    <span id="previousPage" class="dt_previous paginate_button page-item" @click="previousPage">
                                        <i aria-hidden="true" class="fa fa-chevron-left"></i>
                                    </span>
                                    <input id="inputPage" :value="page" class="paginate_input" maxlength="2"
                                           oninput="this.value = this.value.replace(/[^0-9]/g, '');"
                                           type="text" @keyup="inputPageKeyUp" @focusout="inputPageFocusOut" />
                                    <span>&nbsp; {{ translate('label.of') }} </span>
                                    <span id="TotalPages" class="paginate_total">&nbsp;{{ totalPages }}</span>
                                    <span>&nbsp;{{ translate('label.pages') }}</span>
                                    <span id="nextPage" class="dt_next paginate_button page-item" @click="nextPage">
                                       <i aria-hidden="true" class="fa fa-chevron-right"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </nav>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup>
import { ref, computed } from 'vue';
import { usePortfolioStore } from "../storage/storePortfolio";
import { getCampaigns } from "@/portfolio/services/videos-service";
import campaign from "./campaign.vue";
import { useTranslation } from "@/composables/useTranslation"

const { translate } = useTranslation();
const portfolioStore = usePortfolioStore();

const startLimit = ref(0);
const endLimit = ref(12);
const message = ref('');
const totalPages = ref(1);
const type = ref('Success');

const props = defineProps({
    isFetching: {
        type: Boolean,
    },
    limitToShow: {
        type: Number,
        default: 12
    },
});

const campaigns = computed(() => {
    if (props.isFetching == false) {
        let dataFetch = portfolioStore.getCampaignsByPage(portfolioStore.getPageCampaign);
        if (dataFetch != undefined) {
            return dataFetch;
        } else {
            return [];
        }
    } else {
        return [];
    }
});

const totalCampaigns = computed(() => {
    return portfolioStore.getTotalCampaignsGeneral;
})

const getTotalPages = computed(() => {
    const total = portfolioStore.getTotalCampaignsGeneral;
    if (total > 0) {
        totalPages.value = Math.ceil(total / endLimit.value);
    }
    return totalPages.value;
});

const page = computed(() => {
    return portfolioStore.getPageCampaign;
});

async function previousPage() {
    let previewsPage = portfolioStore.getPageCampaign - 1;
    if (previewsPage < 1) {
        previewsPage = 1;
    }
    await updateListByPage(previewsPage);
}

async function nextPage() {
    let nextPage = portfolioStore.getPageCampaign + 1;
    if (nextPage > totalPages.value) {
        nextPage = totalPages.value;
    }
    await updateListByPage(nextPage);
}

async function inputPageKeyUp(event) {
    if (event.target.value !== '') {
        let pageValue = parseInt(event.target.value, 10);
        if (pageValue < 1 || pageValue > totalPages.value) {
            if (pageValue < 1) {
                pageValue = 1;
            } else {
                pageValue = totalPages.value;
            }
        }
        await updateListByPage(pageValue);
    }
}

function inputPageFocusOut(event) {
    if (event.target.value === '') {
        event.target.value = page.value;
    }
}

async function updateListByPage(pageValue) {
    if (!portfolioStore.getCampaignsByPage(pageValue)) {
        startLimit.value = endLimit.value * (pageValue - 1);

        const dataResult = await getCampaigns(false, pageValue, startLimit.value);
        if (dataResult) {
            portfolioStore.addCampaignsByPage({campaigns: dataResult.campaigns, page: dataResult.page});
            portfolioStore.setResultMessage(dataResult.resultMessage);
            portfolioStore.setSiteUrl(dataResult.siteUrl);
        }
        portfolioStore.setPageCampaign(pageValue);
    } else {
        portfolioStore.setPageCampaign(pageValue);
    }
}
</script>
